import { http } from 'utils'
import { SET_ITEMS } from 'vx/mutations'

export default {
  namespaced: true,

  state: {
    xeroItemCodes: []
  },

  actions: {
    async getXeroItemCodes ({ commit, state }, { invoiceRunId, params = {} } = {}) {
      const response = await http.get(`invoice-runs/${invoiceRunId}/xero-item-codes`, { params })

      commit(SET_ITEMS, response.data.data)

      return response
    },

    resetXeroItemCodes ({ commit }) {
      commit(SET_ITEMS, [])
    }
  },

  mutations: {
    [SET_ITEMS] (state, items) {
      state.xeroItemCodes = items
    }
  }
}
